import React, { PureComponent } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import Home from './home/home';
import History from './history/history';
import Account from './account/account';
import { connect } from 'react-redux';
import { getTranslate, withLocalize } from 'react-localize-redux';
import { authLogout } from './login/loginActions';
import logo from '../assets/logo.svg';
import { withActions } from 'actionware';
import NavMenu from './navMenu/navMenu';
import NavMenuMobile from './navMenu/navMenuMobile';
import UserDropdown from './userDropdown/userDropdown';
import Profile from './profile/profile';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import AccountCreationModal from './accountCreation/accountCreationModal';
import Approval from './approval/approval';
import Loan from './loan/loan';
import Transaction from './transaction/transaction';
import TransactionModal from './transaction/transactionModal';

import LanguageToggle from './../views/navMenu/langToggle';
import translations from './../translations';

import Health from './health';
import FundingLimit from './fundingLimit/fundingLimit';
import ConfirmationModal from './confirmationModal/confirmationModal';
import {
  resetToInitialState
} from "./fundingLimit/fundingLimitActions.js";
import LenderRegistrations from './lenderRegistrations/index.jsx';
import LoanAndAgreementDetails from './loan/loanAndAgreementDetails.js';
import { redirectToAuthenticate } from '../helpers/auth.js';
import Authenticated from './authenticated/authenticated.jsx';
import { griffinInstance } from '../common/helpers';

// const defaultLanguage = 'en';
// const languages = Array.from(translations.keys()).map(translation => ({
//   code: translation,
//   name: translation
// }));
const missingTranslationCallback = (key, lang) => {
  console.error(
    `Translation missing for key: ${key} and language code: ${lang}`
  );
};

const { Header, Content } = Layout;

@withRouter
@connect(
  ({ session, localize }) => ({
    translate: getTranslate(localize),
    loggedIn: !!(session && session.authenticated && session.user),
  }),
  dispatch => {
    return bindActionCreators({ push }, dispatch);
  }
)
@withActions({
  authLogout,
  resetToInitialState
})
class App extends React.Component {
  constructor(props) {
    super(props)
    this.props.initialize(
      {
        languages: [
          { name: 'English', code: 'en' },
          { name: 'Indonesian', code: 'id' }
        ],
        options: {
          defaultLanguage: 'id',
          missingTranslationCallback,
          renderToStaticMarkup: false,
          renderInnerHtml: false
        }
      }
    )

    for (const [lang, langTranslations] of translations) {
      this.props.addTranslationForLanguage(langTranslations, lang)
    }
  }

  handleTabClick = (key) => {
    this.props.resetToInitialState();
  }

  renderIfAuthenticated = (AuthenticatedComponent) => {
    return (props) => {
      const [isLoading, setIsLoading] = React.useState(true);
      const [isAuthenticated, setIsAuthenticated] = React.useState(false);
      React.useEffect(() => {
        const checkAuthenticate = async () => {
          try {
            const user = await griffinInstance({ method: "GET", url: `/apis/whoami` });
            setIsAuthenticated(!!user.data);
            setIsLoading(false);
          } catch (e) {
            redirectToAuthenticate();
          }
        };

        checkAuthenticate();
      }, []);

      if (isLoading) {
        return <div> <Spin size="large" /> </div>;
      }

      if (!isLoading) {
        if (isAuthenticated) {
          return (
            <div className={'content-wrapper'}>
              <AuthenticatedComponent {...props} />
            </div>
          );
        } else {
          redirectToAuthenticate();
        }
      }
    };
  };

  notFound = () => {
    return (
      <div>
        <h1>Error</h1>
        <div>Page not found!</div>
      </div>
    );
  };

  render() {
    return (
      <Layout>
        <NavMenuMobile />
        <Layout>
          <Header>
            <div className={'header-content'}>
              <img src={logo} className="logo" alt="logo" />
              <NavMenu handleTabClick={this.handleTabClick} />
              {/* <NotificationsDropdown /> */}
              <UserDropdown />
              <LanguageToggle />
            </div>
          </Header>
          <Content>
            <AccountCreationModal />
            <ConfirmationModal />
            <TransactionModal />
            <Switch>
              <Route
                exact
                path="/"
                component={this.renderIfAuthenticated(Home)}
              />
              <Route
                exact
                path="/authenticated"
                component={Authenticated}
              />
              <Route
                exact
                path="/approval"
                component={this.renderIfAuthenticated(Approval)}
              />
              <Route
                exact
                path="/loan"
                component={this.renderIfAuthenticated(Loan)}
              />
              <Route
                exact
                path="/history"
                component={this.renderIfAuthenticated(History)}
              />
              <Route
                path="/account/:accountId?"
                component={this.renderIfAuthenticated(Account)}
              />
              <Route
                exact
                path="/profile"
                component={this.renderIfAuthenticated(Profile)}
              />
              {/* path '/profile' disable temporary */}

              {/* path '/transaction' is disabled */}
              {/* <Route
                exact
                path="/transaction"
                component={this.renderIfAuthenticated(Transaction)}
              /> */}
              <Route
                exact
                path="/funding-limit"
                component={this.renderIfAuthenticated(FundingLimit)}
              />
              <Route
                exact
                path="/lender-registrations"
                component={this.renderIfAuthenticated(LenderRegistrations)}
              />
              <Route exact path="/health" component={Health} />
              <Route
              path="/loan/details/:application_id"
              component={this.renderIfAuthenticated(LoanAndAgreementDetails)}
              />
              <Route render={this.notFound} />
            </Switch>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default withLocalize(App)
